module.exports = __webpack_public_path__ + "img/Agenda_Octubre.21c368d3.png";